const getSessionsScoreState = (state) => state.sessionsScore;

export default getSessionsScoreState;
